// eslint-no-undef
import React from 'react';
import '../App.css';
import pagina_inicial from '../images/pagina_inicial.png';
import pagina_inicial_blue from '../images/pagina_inicial_blue.png';
import vizinhanca from '../images/vizinhanca.png';
import vizinhanca_blue from '../images/vizinhanca_blue.png';
import mapa from '../images/mapa.png';
import mapa_blue from '../images/mapa_blue.png';
import Footer from './Footer';
import geral from '../images/geral.png';
import geral_blue from '../images/geral_blue.png';
import eventos from '../images/eventos.png';
import eventos_blue from '../images/eventos_blue.png';
import venda from '../images/venda.png';
import venda_blue from '../images/venda_blue.png';
import seguranca from '../images/seguranca.png';
import seguranca_blue from '../images/seguranca_blue.png';

import achados from '../images/achados.png';
import achados_blue from '../images/achados_blue.png';
import votacao from '../images/votacao.png';
import votacao_blue from '../images/votacao_blue.png';

import services from '../images/servicios.png';
import services_blue from '../images/servicios_blue.png';
import members from '../images/vizinhos.png';
import members_blue from '../images/vizinhos_blue.png';


export default class Menu extends React.Component {

  constructor(props) {
    super(props);
    let s = document.createElement('script');
    s.async = true;
    s.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2679096513308609';
    s.crossOrigin = 'anonymous';
    document.head.appendChild(s);
    let bhash = this.buttonHash();
    this.state = {
      'members': bhash['members']['out'],
      'services': bhash['services']['out'],
      'pagina_inicial': bhash['pagina_inicial']['out'],
      'vizinhanca': bhash['vizinhanca']['out'],
      'mapa': bhash['mapa']['out'],
      'geral': bhash['geral']['out'],
      'eventos': bhash['eventos']['out'],
      'venda': bhash['venda']['out'],
      'seguranca': bhash['seguranca']['out'],
      'achados': bhash['achados']['out'],
      'votacao': bhash['votacao']['out'],
    }
  }

  paginaInicial(e) {
    e.preventDefault();
    this.props.app.setCategory(undefined);
  }

  vizinhanca() {
  }
  
  mapa() {
  }

  servicios(event) {
  }

  membros(e) {
    e.preventDefault();
    this.props.app.showNeighbors(e);
  }

  geral(event) {
    event.preventDefault();
    this.props.app.setCategory('Geral');
  }

  eventos(event) {
    event.preventDefault();
    this.props.app.setCategory('Eventos');
  }

  venda(event) {
    event.preventDefault();
    this.props.app.setCategory('Compra e Venda');
  }
 
  seguranca(event) {
    event.preventDefault();
    this.props.app.setCategory('Segurança');
  }

  votacao(event) {
    event.preventDefault();
    this.props.app.setCategory('Votaçao');
  }

  achados(event) {
    event.preventDefault();
    this.props.app.setCategory('Achados e Perdido');
  }

  greyAll() {
    let bhash = this.buttonHash();
    let stateHash = {};
    let appStateCat = this.props.app.state.category;
    for (let entry in bhash) {
      let label = bhash[entry]['label'];
      if (appStateCat && label && label === appStateCat) {
        stateHash[entry] = bhash[entry]['over'];
      } else {
        stateHash[entry] = bhash[entry]['out'];
      }
    }
    this.setState(stateHash); 
  }

  handleMouseOver(event) {
    this.greyAll();
    if (event.target && event.target.id) {
      let stateHash = {};
      stateHash[event.target.id] = this.buttonHash()[event.target.id]['over'];
      this.setState(stateHash);
    }
  }

  handleMouseOut(event) {
    this.greyAll();
  }

  buttonHash() {
    return {
      'members': { over: members_blue, out: members },
      'services': { over: services_blue, out: services },
      'vizinhanca': { over: vizinhanca_blue, out: vizinhanca },
      'pagina_inicial': { over: pagina_inicial_blue, out: pagina_inicial },
      'mapa': { over: mapa_blue, out: mapa },
      'geral': { label: 'Geral', over: geral_blue, out: geral },
      'venda': { label: 'Compra e Venda', over: venda_blue, out: venda },
      'eventos': { label: 'Eventos', over: eventos_blue, out: eventos },
      'seguranca': { label: 'Segurança', over: seguranca_blue, out: seguranca },
      'achados': { label: 'Achados e Perdido', over: achados_blue, out: achados },
      'votacao': { label: 'Votaçao', over: votacao_blue, out: votacao },
    }
  }

  render() {
    let areaName = 'Vizinhança ' + this.props.area.name;
    return (
      <div className='menudiv'>
        <div className='menuInner'>

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.paginaInicial(e)}><img id='pagina_inicial' src={this.state.pagina_inicial} alt='Página Inicial' className='menuIcon' /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} id='pagina_inicial' className='menuItem' onClick={(e) => this.paginaInicial(e)}>Página Inicial</span>
          </div>
  
          <br />
  
          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={this.vizinhanca}><img id='vizinhanca' src={this.state.vizinhanca} alt={areaName} className='menuIcon' onClick={(e) => this.vizinhanca(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='vizinhanca' className='menuItem' onClick={this.vizinhanca}>{areaName}</span>
          </div>
  
          <br />

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={this.mapa}><img id='mapa' src={this.state.mapa} alt='Mapa' className='menuIcon' onClick={(e) => this.mapa(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='mapa' className='menuItem' onClick={this.mapa}>Mapa</span>
          </div>


          <p />
          <div className='genericLabel'>Categorias</div>
          <br />


          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.geral(e)}><img id='geral' src={this.state.geral} alt='Geral' className='menuIcon' onClick={(e) => this.geral(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='geral' className='menuItem' onClick={(e) => this.geral(e)}>Geral</span>
          </div>

          <br />

          <div className='profileMenuImage'onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.eventos(e)}><img id='eventos' src={this.state.eventos} alt='Eventos' className='menuIcon' onClick={(e) => this.eventos(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} id='eventos' href='' className='menuItem' onClick={(e) => this.eventos(e)}>Eventos</span>
          </div>

          <br />

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.venda(e)}><img id='venda' src={this.state.venda} alt='Compra e Venda' className='menuIcon' onClick={(e) => this.venda(e)} /></div>
          <div className='profileMenuLabel'>
            <span id='venda' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' className='menuItem' onClick={(e) => this.venda(e)}>Compra e Venda</span>
          </div>

          <br />

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.seguranca(e)}><img id='seguranca' src={this.state.seguranca} alt='Segurança' className='menuIcon' onClick={(e) => this.seguranca(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='seguranca' className='menuItem' onClick={(e) => this.seguranca(e)}>Segurança</span>
          </div>

          <br />

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.achados(e)}><img id='achados' src={this.state.achados} alt='' className='menuIcon' onClick={(e) => this.achados(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='achados' className='menuItem' onClick={(e) => this.achados(e)}>Achados e Perdido</span>
          </div>

          <br />

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.votacao(e)}><img id='votacao' src={this.state.votacao} alt='' className='menuIcon' onClick={(e) => this.votacao(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='votacao' className='menuItem' onClick={(e) => this.votacao(e)}>Votaçao</span>
          </div>

          <p />
          <div className='genericLabel'>Diretórios</div>
          <br />

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.membros(e)}><img id='members' src={this.state.members} alt='Servicios' className='menuIcon' onClick={(e) => this.membros(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='members' className='menuItem' onClick={(e) => this.membros(e)}>Membros</span>
          </div>

          <br />

          <div className='profileMenuImage' onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} onClick={(e) => this.servicios(e)}><img id='services' src={this.state.services} alt='Servicios' className='menuIcon' onClick={(e) => this.servicios(e)} /></div>
          <div className='profileMenuLabel'>
            <span onMouseOut={(e) => this.handleMouseOut(e)} onMouseOver={(e) => this.handleMouseOver(e)} href='' id='services' className='menuItem' onClick={(e) => this.servicios(e)}>Servicios</span>
          </div>


        </div>
        <div className='greyBack'>
          <Footer />
        </div>
      </div>
    );
  }

}
